import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  inject,
} from '@angular/core';

import { Nillable } from '@web/utils';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  FormControlComponent,
  PrimengButtonDirective,
  PrimengInputTextDirective,
} from '@web/shared/ui';
import { InputTextModule } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { AdminDictionaryCountryDetailsForm } from '../../models/admin-dictionary-country-details-form';

type DictionaryDetailsFormControls = {
  label: FormControl<string>;
  isoCode: FormControl<string>;
  position: FormControl<number>;
};
/* prettier-ignore */
type DictionaryDetailsFormGroup = FormGroup<DictionaryDetailsFormControls>;

@Component({
  selector: 'app-admin-dictionary-country-details-form',
  imports: [
    Button,
    FormControlComponent,
    InputTextModule,
    PrimengButtonDirective,
    PrimengInputTextDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './admin-dictionary-country-details-form.component.html',
  styleUrl: './admin-dictionary-country-details-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminDictionaryCountryDetailsFormComponent {
  private readonly builder = inject(FormBuilder);

  public readonly data = input<Nillable<AdminDictionaryCountryDetailsForm>>();
  /* prettier-ignore */
  public readonly submitClickEvent = output<AdminDictionaryCountryDetailsForm>();

  protected readonly form = this.buildForm();

  public constructor() {
    effect(() => this.fillByData());
  }

  public handleSubmitClick(): void {
    const data = this.form.getRawValue();

    this.submitClickEvent.emit(
      new AdminDictionaryCountryDetailsForm({
        label: data.label,
        position: data.position,
        isoCode: data.isoCode,
      }),
    );
  }

  /* prettier-ignore */
  private buildForm(): DictionaryDetailsFormGroup {
    return this.builder.group({
      label: this.builder.nonNullable.control('', [Validators.required]),
      isoCode: this.builder.nonNullable.control<string>('', [Validators.required]),
      position: this.builder.nonNullable.control(0, [Validators.required, Validators.min(1)]),
    });
  }

  private fillByData(): void {
    const data = this.data();

    this.form.patchValue({
      label: data?.label,
      isoCode: data?.isoCode,
      position: data?.position,
    });
  }
}
